import clsx from 'clsx';
import { avatarColors, initials } from '../../lib/format';

export function Avatar({ name, email, size = 40, className, ring }: { name?: string | null; email: string; size?: number; className?: string; ring?: string }) {
  const label = name?.trim() || email;
  const c = avatarColors(email || label);
  return (
    <span
      aria-hidden
      className={clsx('inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold', className)}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(10, Math.round(size * 0.36)),
        background: c.bg,
        color: c.fg,
        boxShadow: ring ? `0 0 0 2px ${ring}` : undefined,
      }}
    >
      {initials(label)}
    </span>
  );
}
